import React, { FunctionComponent } from 'react';
import Media from 'react-media';
import { SCREEN } from 'scenes/common/types/screen';

import FooterTopDesktop from './FooterTopDesktop';
import FooterTopMobile from './FooterTopMobile';
import { FooterTopProps } from './types';

export const FooterTop: FunctionComponent<FooterTopProps> = ({
  quoteNumber,
  campaign,
  showQuoteInformation,
  pageNotLoadingOrError,
  showFlybuys,
  showFooterQuoteInformation,
  showMarketingCampaign,
  additionalComponents,
  informationLinks,
  insuranceName,
  saveOnlineInformation,
  awardsToDisplay,
  initialAccordionActiveItems,
  isBeforeEffectiveEndDate,
}) => (
  <Media query={{ maxWidth: SCREEN.MEDIUM }}>
    {(matches) =>
      matches ? (
        <FooterTopMobile
          quoteNumber={quoteNumber}
          campaign={campaign}
          showQuoteInformation={showQuoteInformation}
          pageNotLoadingOrError={pageNotLoadingOrError}
          showFlybuys={showFlybuys}
          showFooterQuoteInformation={showFooterQuoteInformation}
          showMarketingCampaign={showMarketingCampaign}
          additionalComponents={additionalComponents}
          informationLinks={informationLinks}
          insuranceName={insuranceName}
          saveOnlineInformation={saveOnlineInformation}
          awardsToDisplay={awardsToDisplay}
          initialAccordionActiveItems={initialAccordionActiveItems}
          isBeforeEffectiveEndDate={isBeforeEffectiveEndDate}
        />
      ) : (
        <FooterTopDesktop
          quoteNumber={quoteNumber}
          campaign={campaign}
          showQuoteInformation={showQuoteInformation}
          pageNotLoadingOrError={pageNotLoadingOrError}
          showFlybuys={showFlybuys}
          showFooterQuoteInformation={showFooterQuoteInformation}
          showMarketingCampaign={showMarketingCampaign}
          additionalComponents={additionalComponents}
          informationLinks={informationLinks}
          insuranceName={insuranceName}
          saveOnlineInformation={saveOnlineInformation}
          awardsToDisplay={awardsToDisplay}
          initialAccordionActiveItems={initialAccordionActiveItems}
          isBeforeEffectiveEndDate={isBeforeEffectiveEndDate}
        />
      )
    }
  </Media>
);

export default FooterTop;
